import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LayoutGrid, Lock, Square, Columns2, Grid3x3, CameraOff } from "lucide-react";
import { api } from "@/lib/api";
import { Brand } from "@/components/Brand";
import { CameraTile } from "@/components/CameraTile";

const LAYOUTS = [
  { cols: 1, icon: Square }, { cols: 2, icon: Columns2 },
  { cols: 3, icon: LayoutGrid }, { cols: 4, icon: Grid3x3 },
];

const Clock = () => {
  const [now, setNow] = useState(new Date());
  useEffect(() => { const i = setInterval(() => setNow(new Date()), 1000); return () => clearInterval(i); }, []);
  return <span className="mono clock" data-testid="header-clock">{now.toLocaleString("pt-BR")}</span>;
};

export default function Home() {
  const [cams, setCams] = useState(null);
  const [cols, setCols] = useState(Number(localStorage.getItem("vl_cols")) || (window.innerWidth < 640 ? 1 : 2));

  useEffect(() => { api.get("/cameras").then((r) => setCams(r.data)).catch(() => setCams([])); }, []);
  useEffect(() => localStorage.setItem("vl_cols", cols), [cols]);

  return (
    <div className="page">
      <header className="topbar">
        <Brand />
        <div className="topbar-right">
          <Clock />
          <div className="layout-switch" data-testid="layout-switch">
            {LAYOUTS.map(({ cols: c, icon: I }) => (
              <button key={c} className={cols === c ? "active" : ""} onClick={() => setCols(c)}
                data-testid={`layout-${c}-btn`} aria-label={`${c} colunas`}><I size={15} /></button>
            ))}
          </div>
          <Link to="/admin" className="btn-ghost" data-testid="admin-link"><Lock size={14} /> Admin</Link>
        </div>
      </header>

      <section className="hero">
        <p className="mono eyebrow">// painel de câmeras</p>
        <h1 className="title">Central de monitoramento</h1>
        <p className="mono meta" data-testid="camera-count">
          {cams ? `${cams.length} câmera${cams.length === 1 ? "" : "s"} cadastrada${cams.length === 1 ? "" : "s"}` : "carregando..."}
        </p>
      </section>

      {cams && cams.length === 0 && (
        <div className="empty" data-testid="empty-state">
          <CameraOff size={36} />
          <p>Nenhuma câmera cadastrada ainda.</p>
          <Link to="/admin" className="btn-primary" data-testid="empty-admin-link">Cadastrar câmeras</Link>
        </div>
      )}

      <main className="cam-grid" style={{ "--cols": cols }} data-testid="camera-grid">
        {cams?.map((c, i) => <CameraTile key={c.id} cam={c} index={i} />)}
      </main>
    </div>
  );
}
